import event2022 from './2022';
import event2023 from './2023';
import event2024 from './2024';
import event2025 from './2025';

export const reckonBallEvents = [event2022, event2023, event2024, event2025];
export const reckonBallByYear = reckonBallEvents.reduce((lookup, event) => ({
  ...lookup,
  [event.year]: event,
}), {});

export function validateReckonBallEvents(events = reckonBallEvents) {
  const years = new Set();
  const slugs = new Set();
  const errors = [];

  events.forEach((event) => {
    if (!event.slug || !event.year || !event.title || !event.hero?.summary || !event.dining) errors.push(`Missing required content for ${event.year || event.slug}`);
    if (years.has(event.year)) errors.push(`Duplicate Reckon Ball year: ${event.year}`);
    if (slugs.has(event.slug)) errors.push(`Duplicate Reckon Ball slug: ${event.slug}`);
    years.add(event.year);
    slugs.add(event.slug);
    if (event.hero?.image && !event.hero.imageAlt) errors.push(`Missing hero alt text for ${event.year}`);
    (event.gallery || []).forEach((image) => { if (!image.alt) errors.push(`Missing gallery alt text for ${event.year}`); });
    (event.dining?.menu?.sections || []).forEach((section) => { if (!section.items?.length) errors.push(`Empty menu section for ${event.year}: ${section.title}`); });
  });

  events.forEach((event) => (event.relatedYears || []).forEach((year) => {
    if (!years.has(year)) errors.push(`Unknown related year ${year} on ${event.year}`);
  }));
  return errors;
}

export const reckonBallValidationErrors = validateReckonBallEvents();

export default reckonBallEvents;
